import { useState, useRef, useCallback, useEffect } from 'react'

type CopyStatus = 'idle' | 'success' | 'error'

export function useCopyToClipboard(resetMs = 2000) {
  const [status, setStatus] = useState<CopyStatus>('idle')
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => () => {
    if (timerRef.current) clearTimeout(timerRef.current)
  }, [])

  const resetAfter = useCallback((newStatus: CopyStatus) => {
    setStatus(newStatus)
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => setStatus('idle'), resetMs)
  }, [resetMs])

  const copy = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      resetAfter('success')
      return true
    } catch {
      resetAfter('error')
      return false
    }
  }, [resetAfter])

  return { status, copy }
}
